import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileTypeIconComponent } from 'filetype-icon-lib';
import { IAttachmentMergeFile } from 'interfaces-lib';

@Component({
  selector: 'lib-compact-file-list-view',
  imports: [CommonModule, DatePipe, MatListModule, MatIconModule, MatButtonModule, MatTooltipModule, FileTypeIconComponent],
  templateUrl: './compact-file-list-view.component.html',
  styleUrl: './compact-file-list-view.component.scss',
})
export class CompactFileListViewComponent {
  @Input() files: IAttachmentMergeFile[] = [];

  @Output()
  actionClick = new EventEmitter<{ item: IAttachmentMergeFile; action: string }>();

  @Output()
  fileSelected = new EventEmitter<IAttachmentMergeFile>();

  selectedFile: IAttachmentMergeFile | null = null;
  focusedIndex: number = 0;
  hasFocus: boolean = false;

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (!this.files || this.files.length === 0 || !this.hasFocus) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.focusedIndex = Math.min(this.focusedIndex + 1, this.files.length - 1);
        this.scrollToFocusedItem();
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.focusedIndex = Math.max(this.focusedIndex - 1, 0);
        this.scrollToFocusedItem();
        break;
      case 'Enter':
        event.preventDefault();
        const focusedFile = this.files[this.focusedIndex];
        if (focusedFile && this.selectedFile !== focusedFile) {
          this.onFileClick(focusedFile);
        }
        break;
    }
  }

  onPreviewClick(file: IAttachmentMergeFile): void {
    this.actionClick.emit({ item: file, action: 'action-preview-file' });
  }

  onListFocus(): void {
    this.hasFocus = true;
  }

  onListBlur(): void {
    this.hasFocus = false;
  }

  onFileClick(file: IAttachmentMergeFile): void {
    this.selectedFile = file;
    this.focusedIndex = this.files.indexOf(file);
    this.fileSelected.emit(file);
  }

  private scrollToFocusedItem(): void {
    const element = document.querySelector('.file-item.focused');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
